<template>
  <el-dialog
    class="login-dialog"
    :show-close="false"
    :visible.sync="showDialog"
    :before-close="handleClose"
  >
    <el-row class="dialog-form-login">
      <div class="login-form">
        <div>
          <img
            @click="handleClose"
            style="position: absolute; top: 0px; right:0; z-index:99999999"
            :src="icons.CloseIcon"
            alt=""
          />
        </div>
        <div class="title-container">
          <h3 class="title mt-10">Notification</h3>
        </div>
        <div style="margin-top: 30px;">
          <p
            style="margin: 0; padding: 0px; text-align: center;   word-wrap: break-word;"
          >
            {{ textMsg }}
          </p>
          <div
            style="display: flex; justify-content: center; margin-top: 10px;"
          >
            <a href=" https://t.me/+9xD_UHwNiOM0NTg9">
              <img :src="icons.SocialZaloIcon" alt=""
            /></a>
            <a href="mailto:freestyle.myapp@gmail.com">
              <img class="mr-10 ml-10" :src="icons.PhoneIcon" alt="" />
            </a>
            <a href="https://www.facebook.com/people/Hocvivu/61561372160944/">
              <img :src="icons.FaceBookIcon" alt="" />
            </a>
          </div>
        </div>
      </div>
    </el-row>
  </el-dialog>
</template>

<script>
import Logo from "@/assets/img/logo/logo.svg";
import SocialMessengerIcon from "@/assets/img/svg/social-messenger.svg";
import SocialZaloIcon from "@/assets/img/svg/telegram-svgrepo-com.svg";
import PhoneIcon from "@/assets/img/svg/email-8-svgrepo-com.svg";
import CloseIcon from "@/assets/img/svg_edu/CloseIcon.svg";
import FaceBookIcon from "@/assets/img/svg/facebook-svgrepo-com.svg";

export default {
  name: "NotiDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    textMsg: {
      type: String,
      default: "hello"
    },
    objectData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      icons: {
        CloseIcon,
        Logo,
        SocialMessengerIcon,
        SocialZaloIcon,
        PhoneIcon,
        FaceBookIcon
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleClose() {
      console.log("vào đây");
      this.$emit("on-close-dialog", false);
    }
  }
};
</script>
<style>
.login-dialog .el-dialog {
  position: relative;
  border-radius: 24px;
  background: #efefef;
  max-width: 450px !important;
  width: 100%;
  min-width: 300px !important;
}
.login-dialog .el-dialog .el-dialog__header {
  padding: 0;
}
</style>
<style lang="scss">
$bg: #fff;
$light_gray: #fff;
$cursor: #000;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .dialog-form-login .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.dialog-form-login {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      height: 47px;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
    .el-input__inner {
      font-size: 15px;
    }
  }

  .el-form-item {
    border: 1px solid rgb(206, 205, 205);
    border-radius: 5px;
  }
}
</style>

<style lang="scss" scoped>
$bg: #fff;
$dark_gray: #eee;
$light_gray: #eee;
.el-dialog {
  width: 30%;
}
.dialog-form-login {
  overflow: hidden;

  .login-form {
    position: relative;
    width: 400px;
    max-width: 100%;
    padding: 0 20px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      margin: 10px auto 20px auto;
      text-align: center;
      font-weight: 700;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
    .el-dialog {
      width: 100%;
    }
  }

  .icon {
    font-size: 24px;
    padding: 0px;
    color: #3c485c;
    background-color: transparent;
    border-color: transparent;
  }
}
</style>
